import { Component, DestroyRef, inject } from '@angular/core';
import { LoginModel } from '../shared/interfaces/loginModel';
import { LoginService } from '../shared/services/login.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '../shared/translate.directive';
import { LoaderService } from '../shared/services/loader.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ErrorComponent } from "../shared/error/error.component";
import { FacebookLoginProvider, GoogleSigninButtonModule, SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, filter } from 'rxjs';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule, TranslateDirective, MatSlideToggleModule, ErrorComponent, GoogleSigninButtonModule],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  loginModel: LoginModel = {
    Email: "",
    Password: "",
    EncriptedPassword: null
  }

  errors: any;
  user: any;
  data: any;
  hasErrors = false;
  rememberMe: any;
  private destroyRef = inject(DestroyRef);

  constructor(private service: LoginService, private router: Router, public myLoaderService: LoaderService, private socialAuthService: SocialAuthService) { }

  ngOnInit() {

    this.socialAuthService.authState
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((user): user is SocialUser => !!user),
        distinctUntilChanged((prev, curr) => prev.id === curr.id && prev.provider === curr.provider)
      )
      .subscribe((user: SocialUser) => {
        this.hasErrors = false;
        this.errors = null;
        if (!user || this.service.isLoggingOut) return;


        if (user.provider === 'GOOGLE') {
          this.service.google(user.idToken).subscribe({
            next: res => this.handleSuccess(res),
            error: err => this.handleError(err)
          });
        }
        else if (user.provider === 'FACEBOOK') {
          this.service.facebook(user.authToken).subscribe({
            next: res => this.handleSuccess(res),
            error: err => this.handleError(err)
          });
        }
      });

    var credentials = this.service.getCredentials();

    if (Object.keys(credentials.pass).length != 0) {
      this.service.decriptCredentials(credentials.pass).subscribe({
        next: res => {
          if (res) {
            this.loginModel.Password = res;
            this.loginModel.Email = credentials.email;
            this.rememberMe = true;
          }
        },
        error: err => {
        }
      })
    }

    this.user = this.service.getUser();
    if (this.user && this.rememberMe) {
      this.router.navigate(['/app-list']);
    }
  }
  login() {
    this.hasErrors = false;
    this.errors = null;

    this.service.login(this.loginModel).subscribe({
      next: res => {
        if (res) {
          this.service.setUser((res as any));
          if (this.rememberMe) {
            this.service.encriptCredentials(this.loginModel).subscribe({
              next: res => {
                if (res) {
                  this.service.saveCredentials(this.loginModel.Email, JSON.stringify(res))
                }
              },
              error: err => {
              }
            })
          }
          else {
            this.service.removeCredentials();
          }
          this.data = res;
          this.service.setUser((res as any));
          this.router.navigate(['/app-list']);
        }
      },
      error: err => {
        this.hasErrors = true;
        this.errors = err?.error?.errors || err?.error || err;
      }
    })

  }

  register() {
    this.router.navigate(['/register']);
  }
  forgot() {
    this.router.navigate(['/forgot-password']);
  }

  signInWithFacebook(): void {

    const fbOptions = {
    scope: 'email,public_profile',
    return_scopes: true,
    enable_profile_selector: true,
    auth_type: 'rerequest' 
  };

    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID,fbOptions).then(() => this.signIn());
  }
  private signIn() {
    
    this.socialAuthService.authState
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((user): user is SocialUser => !!user),
        distinctUntilChanged((prev, curr) => prev.id === curr.id && prev.provider === curr.provider)
      )
      .subscribe((user: SocialUser) => {
        this.hasErrors = false;
        this.errors = null;
        if (!user || this.service.isLoggingOut) return;


        if (user.provider === 'GOOGLE') {
          this.service.google(user.idToken).subscribe({
            next: res => this.handleSuccess(res),
            error: err => this.handleError(err)
          });
        }
        else if (user.provider === 'FACEBOOK') {
         
          this.service.facebook(user.authToken).subscribe({
            next: res => this.handleSuccess(res),
            error: err => this.handleError(err)
          });
        }
      });
  }
  private handleSuccess(res: any): void {
    if (res) {
      this.service.setUser(res);
      this.router.navigate(['/app-list']);
    }
  }

  private handleError(err: any): void {
    this.hasErrors = true;
    this.errors = err?.error?.errors || err?.error || err;
  }
}


